import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-forms-item-modal',
  templateUrl: './forms-item-modal.component.html',
  styleUrls: ['./forms-item-modal.component.css']
})
export class FormsItemModalComponent implements OnInit {

  type: string = '';
  returnData: any;

  dFormParagraphId: string;
  workAreaResult: string = '';
  workAreaArray: string[] = [];
  workAreaData: string[] = [
    '1', '2', '3', '4', '5', '6', '7', '8', '9', '10', '11', '12', '13', '14', '15', '16', '17', '18', '19', '20', '21', '22', '23', '24', '25', '26', '27', '28', '29', '30', '31', '31'
  ];

  actionId: string;

  constructor(
    public dialogRef: MatDialogRef<FormsItemModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
  }

  ngOnInit() {
    this.type = this.data.type;
    this.actionId = this.data.actionId.toUpperCase();
    this.dFormParagraphId = this.data.dFormParagraphId;

    this.dialogRef.beforeClosed().subscribe((res) => {
      console.log('test');
    });
  }

  removeFromWorkArea(option) {
    this.workAreaArray === this.workAreaArray.filter(data => {
      return !(data === option);
    });
  }

  submit() {
    if (this.type === 'WORKAREA') {
      // let returnString = this.workAreaArray.join(' ');
      this.dialogRef.close({proceed: true, data: this.workAreaResult, dFormParagraphId: this.dFormParagraphId});
    }

  }

  cancel() {
    this.dialogRef.close({proceed: false});
  }

  onNotifySave(data: any, guid: string) {
    this.workAreaResult = data;
    switch (guid) {
      case '175927C6-EC08-478F-8527-E6A1AB88CC96':
        // Tooth picker
        this.dialogRef.close({proceed: true, data: this.workAreaResult, dFormParagraphId: this.dFormParagraphId});
        break;
    }
  }
}
